import { useRouter } from 'next/router'
import { enqueueSnackbar } from 'notistack'
import {
  GqlViewerExamReserveInformationDocument,
  useGqlUpdateExamReserveInformationMutation,
} from 'generated/graphql'
import { useChattingContext } from '@app.feature/chatting/chattingContext/module/ChattingContext'
import { TPreReservationFormValues } from '../constants/form'
import { SUCCES_UPDATE_MESSAGE } from '../constants/message'
import { parsedUpdateInputValues } from '../modules/form'

type TUseUpdateExamReservationFn = (isDirty: boolean) => {
  updateExam: (values: TPreReservationFormValues) => Promise<void>
}

const useUpdateExamReservation: TUseUpdateExamReservationFn = (isDirty) => {
  const router = useRouter()
  const { query } = router
  const [updateExamReservation, { loading: updateLoading }] =
    useGqlUpdateExamReserveInformationMutation()
  const { reportToChatting } = useChattingContext()

  const updateExam = async (
    values: TPreReservationFormValues,
  ): Promise<void> => {
    if (!isDirty || updateLoading) {
      return
    }
    const input = parsedUpdateInputValues(values)

    await updateExamReservation({
      variables: {
        input,
      },
      refetchQueries: [GqlViewerExamReserveInformationDocument],
      onCompleted: (data) => {
        reportToChatting({
          type: 'reportChatRefreshMyChatRoom',
        })
        alert(SUCCES_UPDATE_MESSAGE)
        router.replace(
          {
            query: {
              ...query,
              testId:
                data.updateExamReserveInformation.updatedExamReserveInformation
                  .examTest.id,
            },
            hash: 'section1',
          },
          undefined,
          {
            scroll: false,
          },
        )
      },
      onError: (error) => {
        enqueueSnackbar(error.message)
      },
    })
  }
  return { updateExam }
}

export default useUpdateExamReservation
